import type {
  ComputedJavaScriptVariableState,
  SetVariableBooleanTypePayload,
} from '@unifyapps/defs/types/javascriptVariable';
import _isUndefined from 'lodash/isUndefined';

const convertToBoolean = (value: unknown) => {
  if (typeof value === 'string') {
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue === 'false') return false;
    if (lowerCaseValue === 'true') return true;
  }
  return Boolean(value);
};

/**
 * Any change here should be reflected in the METHODS_DOCUMENTATION.md file
 */
export function getNextPageVariableStateForBoolean({
  variableState,
  operationDetails,
}: {
  variableState: ComputedJavaScriptVariableState<unknown>;
  operationDetails: {
    operation?: SetVariableBooleanTypePayload['operationDetails']['operation'];
    value?: unknown;
  };
}) {
  switch (operationDetails.operation) {
    case 'SET': {
      // SET allows undefined to reset the variable, or any value (converted to boolean)
      return {
        ...variableState,
        value: _isUndefined(operationDetails.value)
          ? undefined
          : convertToBoolean(operationDetails.value),
      };
    }
    case 'TOGGLE': {
      // TOGGLE works on current value (undefined becomes true, false becomes true, true becomes false)
      return {
        ...variableState,
        value: !convertToBoolean(variableState.value),
      };
    }
    default:
      return variableState;
  }
}
